<div class="nuria-chat" *ngIf="isOpen$ | async" [class.nuria-chat--expanded]="isExpanded">

   <!-- Header -->
   <div class="nuria-chat__header">
      <div class="nuria-chat__title">
         <div class="nuria-chat__avatar">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#2d3e50" aria-hidden="true">
               <path d="M12 2L13.8 9.2L21 12L13.8 14.8L12 22L10.2 14.8L3 12L10.2 9.2Z"/>
               <circle cx="19" cy="5" r="2" opacity="0.7"/>
            </svg>
         </div>
         <span>{{ 'DATA.COMMON.NURIA_CHAT.TITLE' | translate }}</span>
         <span
            class="nuria-chat__dot"
            [class.nuria-chat__dot--connecting]="(status$ | async) === 'connecting'"
            [class.nuria-chat__dot--connected]="(status$ | async) === 'connected'"
         ></span>
         <span class="nuria-chat__status-label">{{ (status$ | async) ?? '' | translate }}</span>
      </div>
      <div class="nuria-chat__actions">
         <button
            class="nuria-chat__action-btn"
            [class.nuria-chat__action-btn--active]="feedbackOpen"
            (click)="toggleFeedback()"
            [title]="'DATA.COMMON.NURIA_CHAT.RATE_TOOLTIP' | translate"
         >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
               <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3z"/>
               <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
            </svg>
         </button>
         <button
            class="nuria-chat__action-btn"
            (click)="toggleExpand()"
            [title]="(isExpanded ? 'DATA.COMMON.NURIA_CHAT.COLLAPSE' : 'DATA.COMMON.NURIA_CHAT.EXPAND') | translate"
         >
            <svg *ngIf="!isExpanded" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
               <polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/>
               <line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>
            </svg>
            <svg *ngIf="isExpanded" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
               <polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/>
               <line x1="10" y1="14" x2="3" y2="21"/><line x1="21" y1="3" x2="14" y2="10"/>
            </svg>
         </button>
         <button
            class="nuria-chat__action-btn"
            (click)="close()"
            [title]="'DATA.COMMON.NURIA_CHAT.CLOSE' | translate"
         >&#x2715;</button>
      </div>
   </div>

   <!-- Overall feedback screen (replaces messages + footer) -->
   <ng-container *ngIf="feedbackOpen; else chatBody">

      <!-- Sent confirmation -->
      <div class="nuria-chat__feedback-screen" *ngIf="feedbackSent; else rateForm">
         <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>
         </svg>
         <p class="nuria-chat__feedback-screen-title">{{ 'DATA.COMMON.NURIA_CHAT.FEEDBACK_SENT_TITLE' | translate }}</p>
         <p class="nuria-chat__feedback-screen-sub">{{ 'DATA.COMMON.NURIA_CHAT.FEEDBACK_SENT_SUBTITLE' | translate }}</p>
      </div>

      <!-- Rating form -->
      <ng-template #rateForm>
         <div class="nuria-chat__feedback-screen">
            <p class="nuria-chat__feedback-screen-title">{{ 'DATA.COMMON.NURIA_CHAT.RATE_TITLE' | translate }}</p>
            <div class="nuria-chat__stars">
               <button
                  *ngFor="let star of [1,2,3,4,5]"
                  class="nuria-chat__star"
                  [class.nuria-chat__star--active]="star <= overallRating"
                  (click)="setOverallRating(star)"
                  [title]="star + ' ' + ((star > 1 ? 'DATA.COMMON.NURIA_CHAT.STARS' : 'DATA.COMMON.NURIA_CHAT.STAR') | translate)"
               >&#9733;</button>
            </div>
            <input
               class="nuria-chat__feedback-screen-input"
               type="text"
               [(ngModel)]="overallComment"
               [placeholder]="'DATA.COMMON.NURIA_CHAT.COMMENT_PLACEHOLDER' | translate"
               (keydown.enter)="sendOverallFeedback()"
               autocomplete="off"
            />
            <button
               class="nuria-chat__feedback-screen-submit"
               (click)="sendOverallFeedback()"
               [disabled]="!overallRating"
            >
               {{ 'DATA.COMMON.NURIA_CHAT.SEND_FEEDBACK' | translate }}
            </button>
         </div>
      </ng-template>

   </ng-container>

   <!-- Normal chat body -->
   <ng-template #chatBody>
      <div class="nuria-chat__messages" #messageList>
         <div *ngIf="(status$ | async) === 'connecting'" class="nuria-chat__system">
            {{ 'DATA.COMMON.NURIA_CHAT.CONNECTING' | translate }}
         </div>
         <div
            *ngIf="(status$ | async) === 'connected' && (messages$ | async)?.length === 0"
            class="nuria-chat__system"
         >
            {{ 'DATA.COMMON.NURIA_CHAT.SESSION_STARTED' | translate }}
         </div>
         <div
            *ngFor="let msg of messages$ | async"
            class="nuria-chat__msg"
            [class.nuria-chat__msg--agent]="msg.role === 'agent'"
            [class.nuria-chat__msg--user]="msg.role === 'user'"
            [innerHTML]="msg.text | chatMessage"
         ></div>

         <!-- Typing indicator -->
         <div class="nuria-chat__msg nuria-chat__msg--agent nuria-chat__typing" *ngIf="isAgentWriting$ | async">
            <span class="nuria-chat__typing-dot"></span>
            <span class="nuria-chat__typing-dot"></span>
            <span class="nuria-chat__typing-dot"></span>
         </div>
      </div>

      <div class="nuria-chat__footer">
         <!-- Per-message feedback (thumbs, shown by SDK) -->
         <div class="nuria-chat__feedback" *ngIf="canSendFeedback$ | async">
            <div class="nuria-chat__feedback-top">
               <span class="nuria-chat__feedback-label">{{ 'DATA.COMMON.NURIA_CHAT.PER_MSG_QUESTION' | translate }}</span>
               <div class="nuria-chat__feedback-btns">
                  <button
                     class="nuria-chat__feedback-btn nuria-chat__feedback-btn--like"
                     [class.nuria-chat__feedback-btn--selected]="feedbackRating === true"
                     (click)="selectRating(true)"
                     [title]="'DATA.COMMON.NURIA_CHAT.PER_MSG_LIKE' | translate"
                  >
                     <i class="pi pi-thumbs-up"></i>
                  </button>
                  <button
                     class="nuria-chat__feedback-btn nuria-chat__feedback-btn--dislike"
                     [class.nuria-chat__feedback-btn--selected]="feedbackRating === false"
                     (click)="selectRating(false)"
                     [title]="'DATA.COMMON.NURIA_CHAT.PER_MSG_DISLIKE' | translate"
                  >
                     <i class="pi pi-thumbs-down"></i>
                  </button>
               </div>
            </div>
            <div class="nuria-chat__feedback-input-row" *ngIf="feedbackRating !== null">
               <input
                  class="nuria-chat__feedback-input"
                  type="text"
                  [(ngModel)]="feedbackText"
                  [placeholder]="'DATA.COMMON.NURIA_CHAT.COMMENT_PLACEHOLDER' | translate"
                  (keydown.enter)="sendFeedback()"
                  autocomplete="off"
               />
               <button
                  class="nuria-chat__feedback-submit"
                  (click)="sendFeedback()"
                  [title]="'DATA.COMMON.NURIA_CHAT.SEND_FEEDBACK' | translate"
               >
                  <i class="pi pi-send"></i>
               </button>
            </div>
         </div>

         <div class="nuria-chat__input-row">
            <input
               class="nuria-chat__input"
               type="text"
               [(ngModel)]="inputText"
               (keydown.enter)="send()"
               [placeholder]="'DATA.COMMON.NURIA_CHAT.PLACEHOLDER' | translate"
               [disabled]="(status$ | async) !== 'connected'"
               autocomplete="off"
            />
            <button
               class="nuria-chat__send"
               (click)="send()"
               [disabled]="(status$ | async) !== 'connected' || !inputText.trim()"
            >
               <i class="pi pi-send"></i>
            </button>
         </div>
      </div>
   </ng-template>

</div>
